import { AlertTriangle, ImageOff } from "lucide-react";
import { imgSrc } from "@/lib/api";

const isOutside = (url) => /^https?:\/\//i.test(url || "");

// "ok" | "missing" | "broken" | "outside"
export const photoProblem = (m, broken) => {
  if (!m.image_url) return "missing";
  if (broken) return "broken";
  if (isOutside(m.image_url)) return "outside";
  return "ok";
};

const MSG = {
  missing: "No photo yet",
  broken: "Photo can't load. Re-upload it",
  outside: "Outside link, may stop working. Re-upload it",
};

export const MemberThumb = ({ m, broken, onBroken }) => (
  <div className="w-16 h-16 shrink-0 bg-black border border-white/10 grid place-items-center overflow-hidden">
    {m.image_url && !broken ? (
      <img src={imgSrc(m.image_url)} alt={m.name} onError={() => onBroken(m.id)} className="w-full h-full object-cover grayscale" />
    ) : (
      <ImageOff size={20} className={broken ? "text-[#FF8080]" : "text-zinc-500"} />
    )}
  </div>
);

export const PhotoWarning = ({ problem, testId, onFix }) =>
  problem === "ok" ? null : (
    <button type="button" data-testid={testId} onClick={onFix} className={`mt-2 inline-flex items-center gap-2 px-2 py-1 font-mono text-[11px] uppercase tracking-[0.12em] border text-left ${problem === "missing" ? "border-zinc-600 text-zinc-300" : "border-[#FF5A5A] text-[#FF8080] hover:bg-[#FF5A5A] hover:text-black"} transition-colors`}>
      <AlertTriangle size={12} className="shrink-0" /> {MSG[problem]}
    </button>
  );

export const PhotoAlertBanner = ({ count, testId }) =>
  count > 0 ? (
    <div data-testid={testId} className="mb-4 flex items-start gap-3 border border-[#FF5A5A]/60 bg-[#FF5A5A]/10 p-4 text-sm text-zinc-200">
      <AlertTriangle size={18} className="text-[#FF8080] shrink-0 mt-0.5" />
      <span>{count} photo{count === 1 ? "" : "s"} here won't show on the website or app. Tap the red warning on the card to upload a new photo.</span>
    </div>
  ) : null;
